//后端接口请求地址
// BASE_V_API = 'https://www.revonft.com/api'
console.log('process.env.VUE_APP_SERVER_ENV:', process.env.VUE_APP_SERVER_ENV)
console.log()
const backend_env = (process.env.VUE_APP_SERVER_ENV || 'prod').trim()

let BASE_V_API;
let ContractUrl;
let BASE_GLOB_API;

if (backend_env === 'dev') {
    BASE_V_API = '/api';
    // 后端合约请求地址
    ContractUrl = 'https://www.revodev.com/chain/';
    // 后端接口请求地址
    // http://34.57.53.215:8547
    // // BASE_GLOB_API = 'http://revodev:9099/revow';
    // BASE_GLOB_API = 'https://www.revodev.cc/revow';
    BASE_GLOB_API = 'http://34.57.53.215:9099/revow';
    console.log('Using dev backend');
} else if (backend_env === 'uat') {
    BASE_V_API = '/api';
    // 后端合约请求地址
    ContractUrl = 'https://www.revonft.com/chain/';
    // 后端接口请求地址
    // http://34.57.53.215:8547
    BASE_GLOB_API = 'http://34.57.53.215:9099/revow';
    // BASE_GLOB_API = 'https://www.revodev.cc/revow';
} else {
    BASE_V_API = '/api';
    ContractUrl = 'https://www.rebitnft.com/chain/';
    BASE_GLOB_API = 'https://www.rebitnft.com/revow';
    console.log('Using prod backend');
}

const EnableCountDown = false; // 是否启用倒计时

// rtvtoken 地址
const rtvtokenAddress = "0xf07FcEeCab2339AbE8322fe40C1331bda1ac9E5f"
// Rtv721 地址
const Rtv721Address = "0xDCcfb29523B9eb243DE5F1ad445d5B49F48DB46A"
// market 地址
const marketAddress = "0xEb472015a30C1F340850B12dbE4c7BF84fAf0C90"
//水龙头地址
const FaucetAddress='https://www.revonft.com/faucet/'

const BASE_RANKING_API = 'https://www.revonft.com/voting';
const API_KEY = '19dffbc5117577ad4f5e66dada8da19d';
const THE_GRAPH_API = 'https://gateway.thegraph.com/api/'+API_KEY+'/subgraphs/id/EYCKATKGBKLWvSfwvBjzfCBmGwYNdVkduYXVivCsLRFu'

//白皮书地址
const Whitepaper='https://www.revonft.com/book/RevolutionwhitepaperEnglish.pdf'
//doc
const doc='https://revonft.gitbook.io/'
//表单
const formData="https://forms.gle/uYTAKKWgrZNJzkKx6"
//以太坊查看 携带hash
const etherscan="https://etherscan.io/tx/"

const install='https://www.revonft.com/app/Wallet-release.apk'


// 铸造 价格
const mintPrice="0.03"
// 游戏时长
const countDownTime=86400; // 单位 秒(s)
// 投票价格
const votePrice="0.01"
export  {
    THE_GRAPH_API,
    BASE_GLOB_API,
    BASE_V_API,
    BASE_RANKING_API,
    ContractUrl,
    rtvtokenAddress,
    Rtv721Address,
    marketAddress,
    FaucetAddress,
    Whitepaper,
    doc,
    formData,
    etherscan,
    install,
    mintPrice,
    countDownTime,
    votePrice,
    EnableCountDown
}